<template>
  <div class="nb-page">
    <div
      class="nb-main"
      v-loading="loading"
    >
      <el-steps
        :active="stepActive"
        align-center
        style="margin: 20px 0;"
      >
        <el-step
          title="填写投保信息"
          :status="stepIcon(0)"
        />
        <el-step
          title="投保审核"
          :status="stepIcon(1)"
        />
        <el-step
          title="支付完成"
          :status="stepIcon(2)"
        />
        <el-step
          title="投保成功"
          :status="stepIcon(3)"
        />
      </el-steps>

      <div
        class="status-line"
        v-if="order"
      >
        当前状态：<span :class="statusClass">{{ statusDesc }}</span>
        <template v-if="order.auditFailReason">
          —— 失败原因：{{ order.auditFailReason }}
        </template>
      </div>

      <div class="plate-title">
        投保信息
      </div>
      <div class="detail-grid">
        <div class="row">
          <div class="dl">
            订单号
          </div><div class="dv">
            {{ order.orderCode }}
          </div>
        </div>
        <div class="row">
          <div class="dl">
            上游申请流水号
          </div><div class="dv">
            {{ order.applyno }}
          </div>
        </div>
        <div class="row">
          <div class="dl">
            投保企业名称
          </div><div class="dv">
            {{ order.companyName }}
          </div>
        </div>
        <div
          v-if="order.qualification"
          class="row"
        >
          <div class="dl">
            企业资质
          </div><div class="dv">
            {{ order.qualification }}
          </div>
        </div>
        <div class="row">
          <div class="dl">
            保函类型
          </div><div class="dv">
            {{ typeDesc }}
          </div>
        </div>
        <div class="row">
          <div class="dl">
            担保金额(元)
          </div><div class="dv">
            {{ order.sumAmount }}
          </div>
        </div>
        <div class="row">
          <div class="dl">
            保费(元)
          </div><div class="dv">
            {{ order.sumPremium || (order.approvedPremium || '待机构核定') }}
          </div>
        </div>
        <div class="row">
          <div class="dl">
            项目名称
          </div><div class="dv">
            {{ order.projectName }}
          </div>
        </div>
        <div class="row">
          <div class="dl">
            标段名称
          </div><div class="dv">
            {{ order.sectionName }}
          </div>
        </div>
      </div>

      <!-- 待支付：跳转机构支付页 -->
      <div
        v-if="order.status === 'APPROVED'"
        style="text-align: center; margin: 40px 0;"
      >
        <el-button
          type="primary"
          @click="onPay"
        >
          立即支付
        </el-button>
        <div class="tip">
          点击支付将跳转至出函机构支付页面完成缴纳，金骊保仅做跳转
        </div>
      </div>

      <!-- 出函成功：保函信息与下载 + 发票/退保入口 -->
      <template v-if="order.status === 'ISSUED'">
        <div
          class="plate-title"
          style="margin-top: 20px;"
        >
          保函信息
        </div>
        <div class="detail-grid">
          <div class="row">
            <div class="dl">
              保函编号
            </div><div class="dv">
              {{ order.guaranteeNumber }}
            </div>
          </div>
          <div class="row">
            <div class="dl">
              出函时间
            </div><div class="dv">
              {{ fmtTime(order.issueTime) }}
            </div>
          </div>
          <div class="row">
            <div class="dl">
              有效期
            </div><div class="dv">
              {{ fmtTime(order.guaranteeStartDate, 'date') }} 至 {{ fmtTime(order.guaranteeEndDate, 'date') }}
            </div>
          </div>
        </div>
        <div
          class="file-card"
          v-if="order.guaranteeUrl"
        >
          <span>保函文件</span>
          <el-button
            type="text"
            @click="download(order.guaranteeUrl)"
          >
            下载保函
          </el-button>
        </div>
        <!-- 发票/退保入口暂不放开（流程待确认），放开时将 showInvoiceRefund 改为 true -->
        <div
          v-if="showInvoiceRefund"
          class="actions"
        >
          <el-button @click="invoiceVisible = true">
            申请发票
          </el-button>
          <el-button @click="refundVisible = true">
            申请退保
          </el-button>
        </div>

        <!-- 申请发票弹窗 -->
        <el-dialog
          title="申请发票"
          :visible.sync="invoiceVisible"
          width="480px"
        >
          <el-form
            :model="invoiceForm"
            label-width="120px"
            size="small"
          >
            <el-form-item label="发票类型">
              <el-radio-group v-model="invoiceForm.invoiceType">
                <el-radio label="5">
                  电子普票
                </el-radio>
                <el-radio label="6">
                  电子专票
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="发票抬头"
              required
            >
              <el-input v-model="invoiceForm.invoiceHead" />
            </el-form-item>
            <el-form-item
              label="纳税人识别号"
              required
            >
              <el-input v-model="invoiceForm.cuscCode" />
            </el-form-item>
            <el-form-item label="开票金额(元)">
              <el-input
                :value="order.sumPremium"
                disabled
              />
            </el-form-item>
            <el-form-item
              label="手机号"
              required
            >
              <el-input v-model="invoiceForm.mobile" />
            </el-form-item>
            <el-form-item
              label="接收邮箱"
              :required="invoiceForm.invoiceType === '5'"
            >
              <el-input v-model="invoiceForm.email" />
            </el-form-item>
            <template v-if="invoiceForm.invoiceType === '6'">
              <el-form-item
                label="公司地址"
                required
              >
                <el-input v-model="invoiceForm.addInfo" />
              </el-form-item>
              <el-form-item
                label="公司电话"
                required
              >
                <el-input v-model="invoiceForm.phoneNo" />
              </el-form-item>
              <el-form-item
                label="开户行"
                required
              >
                <el-input v-model="invoiceForm.bankInfo" />
              </el-form-item>
              <el-form-item
                label="银行帐号"
                required
              >
                <el-input v-model="invoiceForm.bankAcc" />
              </el-form-item>
            </template>
          </el-form>
          <div slot="footer">
            <el-button @click="invoiceVisible = false">
              取 消
            </el-button>
            <el-button
              type="primary"
              @click="submitInvoice"
              :loading="invoicing"
            >
              确认开票
            </el-button>
          </div>
        </el-dialog>

        <!-- 申请退保弹窗 -->
        <el-dialog
          title="申请退保"
          :visible.sync="refundVisible"
          width="480px"
        >
          <el-form
            :model="refundForm"
            label-width="120px"
            size="small"
          >
            <el-form-item label="保函编号">
              <el-input
                :value="order.guaranteeNumber"
                disabled
              />
            </el-form-item>
            <el-form-item
              label="退保原因"
              required
            >
              <el-input
                type="textarea"
                v-model="refundForm.refundReason"
              />
            </el-form-item>
            <el-form-item
              label="退款账户名"
              required
            >
              <el-input v-model="refundForm.accountName" />
            </el-form-item>
            <el-form-item
              label="退款开户行"
              required
            >
              <el-input v-model="refundForm.bankName" />
            </el-form-item>
            <el-form-item
              label="退款银行账号"
              required
            >
              <el-input v-model="refundForm.bankNo" />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="refundVisible = false">
              取 消
            </el-button>
            <el-button
              type="primary"
              @click="submitRefund"
              :loading="refunding"
            >
              确认申请
            </el-button>
          </div>
        </el-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import { detail, payUrl, applyInvoice, applyRefund } from '@/api/nonbid.js';

const TYPE_DESC = { 1: '履约保函', 2: '农民工工资保函', 3: '工程质量保函', 4: '工程款支付保函', 5: '安责险' };
const STATUS_DESC = {
  INITIAL: '初始状态（填写中）', AUDITING: '待审核——出函机构正在审核，结果将同步上游',
  APPROVED: '审核通过，请完成保费支付', PAY_SUCCESS: '支付成功（待出函）——保函开立以机构回传为准',
  AUDIT_FAIL: '审核失败——订单已结束', ISSUED: '出函成功',
  ISSUE_FAIL: '出函失败——订单已结束', CANCELED: '订单已取消',
  REFUND_APPLY: '退保处理中', REFUND_SUCCESS: '退保成功', REFUND_FAIL: '退保失败（保函继续有效）',
};
const STEP_MAP = { INITIAL: 0, AUDITING: 1, APPROVED: 2, PAY_SUCCESS: 3, ISSUED: 4 };

export default {
  data() {
    return {
      loading: false,
      order: {},
      // 发票/退保入口开关：流程确认后放开
      showInvoiceRefund: false,
      invoiceVisible: false,
      refundVisible: false,
      invoicing: false,
      refunding: false,
      invoiceForm: {
        invoiceType: '5', invoiceHead: '', cuscCode: '', mobile: '', email: '',
        addInfo: '', phoneNo: '', bankInfo: '', bankAcc: '',
      },
      refundForm: { refundReason: '', accountName: '', bankName: '', bankNo: '' },
    };
  },
  computed: {
    orderCode() {
      return this.$route.query.orderCode;
    },
    typeDesc() {
      return TYPE_DESC[this.order.guaranteeType] || this.order.guaranteeType;
    },
    statusDesc() {
      return STATUS_DESC[this.order.status] || this.order.status;
    },
    statusClass() {
      const s = this.order.status;
      if (s === 'ISSUED' || s === 'PAY_SUCCESS' || s === 'REFUND_SUCCESS') return 'green';
      if (s === 'AUDIT_FAIL' || s === 'ISSUE_FAIL' || s === 'CANCELED' || s === 'REFUND_FAIL') return 'red';
      return 'blue';
    },
    stepActive() {
      return STEP_MAP[this.order.status] || 0;
    },
  },
  created() {
    const key = this.$route.query.orderCode || this.$route.query.applyno;
    if (!key) {
      this.$message.error('缺少订单标识');
      return;
    }
    this.loadDetail(key);
  },
  methods: {
    // 时间戳（毫秒）或日期字符串统一格式化；mode=date 只显示到日
    fmtTime(val, mode) {
      if (val === null || val === undefined || val === '') {
        return '';
      }
      const n = Number(val);
      const d = isNaN(n) ? new Date(String(val).replace(/-/g, '/')) : new Date(n);
      if (isNaN(d.getTime())) {
        return String(val);
      }
      const p = x => (x < 10 ? '0' + x : '' + x);
      const date = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
      return mode === 'date' ? date
        : date + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
    },
    stepIcon(idx) {
      return this.stepActive > idx ? 'success' : (this.stepActive === idx ? 'process' : 'wait');
    },
    loadDetail(key) {
      this.loading = true;
      detail({ applyno: key, orderNo: key }).then(({ data }) => {
        this.order = (data.data || {}).order || {};
      }).finally(() => {
        this.loading = false;
      });
    },
    onPay() {
      payUrl({ orderNo: this.order.orderCode }).then(({ data }) => {
        const url = (data.data || {}).payUrl;
        if (url) {
          window.open(url);
        } else {
          this.$message.error('未获取到支付链接');
        }
      });
    },
    download(url) {
      // MinIO 相对路径走非投标免登录文件接口，完整 URL 直接打开
      const full = url && url.indexOf('http') === 0 ? url
        : (process.env.VUE_APP_FIRST_URL || '') + '/api/nonbid/apply/readFile?applyno='
          + (this.order.orderCode || this.order.applyno) + '&source=' + encodeURIComponent(url);
      window.open(full);
    },
    submitInvoice() {
      if (!this.invoiceForm.invoiceHead || !this.invoiceForm.cuscCode || !this.invoiceForm.mobile) {
        this.$message.error('请填写发票抬头、纳税人识别号与手机号');
        return;
      }
      if (this.invoiceForm.invoiceType === '5' && !this.invoiceForm.email) {
        this.$message.error('电子普票请填写接收邮箱');
        return;
      }
      this.invoicing = true;
      const payload = {
        ...this.invoiceForm,
        orderCode: this.order.orderCode,
        guaranteeNumber: this.order.guaranteeNumber,
        amount: this.order.sumPremium,
      };
      applyInvoice(payload).then(({ data }) => {
        if (Number(data.status) === 200 || Number(data.code) === 200) {
          this.$message.success('开票申请已提交，出函机构开票完成后可下载发票');
          this.invoiceVisible = false;
        } else {
          this.$message.error(data.errorMsg || data.message || '提交失败');
        }
      }).finally(() => {
        this.invoicing = false;
      });
    },
    submitRefund() {
      if (!this.refundForm.refundReason || !this.refundForm.accountName
        || !this.refundForm.bankName || !this.refundForm.bankNo) {
        this.$message.error('请填写退保原因与完整退款账户信息');
        return;
      }
      this.refunding = true;
      const payload = {
        ...this.refundForm,
        orderCode: this.order.orderCode,
        guaranteeNumber: this.order.guaranteeNumber,
      };
      applyRefund(payload).then(({ data }) => {
        if (Number(data.status) === 200 || Number(data.code) === 200) {
          this.$message.success('退保申请已提交，出函机构处理完成后同步结果');
          this.refundVisible = false;
          this.loadDetail(this.order.orderCode);
        } else {
          this.$message.error(data.errorMsg || data.message || '提交失败');
        }
      }).finally(() => {
        this.refunding = false;
      });
    },
  },
};
</script>

<style scoped>
.nb-page { background: #fff; min-height: 100vh; }
.nb-header { display: flex; justify-content: space-between; align-items: center; padding: 10px 40px; border-bottom: 1px solid #eee; }
.nb-logo { font-size: 20px; font-weight: bold; color: #333; }
.nb-phone { font-size: 14px; color: #0E52D4; }
.nb-main { margin: 0 40px 40px; }
.plate-title { font-size: 17px; font-weight: bold; color: #000; padding-left: 12px; margin: 12px 0 16px; position: relative; }
.plate-title::before { content: " "; position: absolute; left: 0; top: 50%; margin-top: -8px; width: 4px; height: 16px; background: #0E52D4; border-radius: 2px; }
.status-line { font-size: 15px; margin: 10px 0; }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; }
.row { display: flex; margin-bottom: 4px; }
.dl { width: 180px; color: #666; padding: 6px 0; flex-shrink: 0; }
.dv { color: #333; padding: 6px 0; }
.blue { color: #0E52D4; }
.red { color: #f5222d; }
.green { color: #52c41a; }
.tip { color: #999; font-size: 12px; margin-top: 10px; }
.file-card { display: flex; justify-content: space-between; align-items: center; background: #f0f8ff; border-radius: 4px; padding: 8px 12px; font-size: 13px; margin-bottom: 10px; }
</style>
